"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M18.8419 11.808L11.9472 13.3542L15.3183 1.24727C15.6112 0.195024 14.2393 -0.479068 13.6242 0.417139L0.176222 20.0117C-0.329423 20.7485 0.329705 21.7373 1.18243 21.5219L7.32584 19.9709L3.9657 32.0894C3.67619 33.1336 5.02403 33.7991 5.6464 32.9381L19.8102 13.3435C20.3329 12.6203 19.6992 11.6158 18.8419 11.808Z"
}), 'Lightning', {
  viewBox: '0 0 20 34'
});

exports.default = _default;